import React, { useEffect, useState } from "react";
import { IProjectModel, ProjectTypeEnum, ProjectTypeEnum1, ProjectTypeEnum2, dataanalyticsEngineTypes, docAiEngineTypes, ebookEngyneTypes, embeddedModelTypes, embeddedModelTypesUpdated, engineTypes, openAITypes, openAikeyTypes, openSourceTypes, researchInsightsEngineTypes } from "../../models/SharedModel";
import { Form } from "react-router-dom";
import { FormGroup, Input, Label, Button } from "reactstrap";
import { compareVersions, text_convert_lower } from "../../helpers/GenericHelpers";
import { folderNameRegex, verisonRegex } from "../../helpers/RegexHelpers";

interface IProjectFormProps {
  project: Partial<IProjectModel> | null;
  setProject: React.Dispatch<React.SetStateAction<Partial<IProjectModel> | null>>;
  submitProject: Function;
  cancelProject: Function;
  selectedProject?: IProjectModel | null | undefined;
}

const ProjectForm = (props: IProjectFormProps) => {
  const { project, setProject, submitProject, selectedProject, cancelProject } = props;

  // states
  const [errors, setErrors] = useState<Partial<IProjectModel>>({});

  // helpers functions
  const handleChange = (value: any, field: string) => {
    if (field === 'engine') {
      if(value==='open_ai'){
        setModels(engineModels[0]?.models)
        setProject((prev) => ({
          ...(prev ?? {}),
          model: engineModels[0]?.models[0],
        }));
      }else if(value==='open_source'){
        setModels(engineModels[1]?.models)
        setProject((prev) => ({
          ...(prev ?? {}),
          model: engineModels[1]?.models[0],
        }));
      }
    }
    setProject((prev) => ({
      ...(prev ?? {}),
      [field]: value || "",
    }));
  };

  useEffect(() => {
    let currentModels:any = undefined
    if(project?.project_type === ProjectTypeEnum.DOCUMENT_AI){
      currentModels = docAiEngineTypes
    } if(project?.project_type === ProjectTypeEnum.RESEARCH_INSIGHTS){
      currentModels = researchInsightsEngineTypes
    }if(project?.project_type === ProjectTypeEnum.EBOOK__INSIGHTS){
      currentModels = ebookEngyneTypes
    }if(project?.project_type === ProjectTypeEnum.DATA_ANALYTICS){
      currentModels = dataanalyticsEngineTypes
    } 

    setModels(currentModels)
    setDynamicModels(currentModels)
    setProject((prev) => ({
      ...(prev ?? {}),
      'model': currentModels && currentModels[0] || "",
    }));
  }, [project?.project_type])
  

  const validateFields = (value: string, field: string) => {
    if (field === "project_name") {
      if (!value.match(folderNameRegex)) {
        setErrors((prev) => ({
          ...(prev ?? {}),
          [field]: 'Only alphabets, 0-9, "_" are allowed for Name',
        }));
      } else {
        setErrors((prev) => {
          if (prev && (prev as any)?.[field]) {
            delete (prev as any)?.[field];
            return prev;
          } else return {};
        });
      }
    } else if (field === "version") {
      if (!value.match(verisonRegex)) {
        setErrors((prev) => ({
          ...(prev ?? {}),
          [field]: 'Only 0-9, "." are allowed for Version',
        }));
      } else if (compareVersions(value, selectedProject?.version || "0.1") <= 0) {
        setErrors((prev) => ({
          ...(prev ?? {}),
          [field]: 'Please enter a version more than the previous version.',
        }));
      } else {
        setErrors((prev) => {
          if (prev && (prev as any)?.[field]) {
            delete (prev as any)?.[field];
            return prev;
          } else return {};
        });
      }
    }else if(field === 'project_description'){
      if(value.length < 1){
        setErrors((prev) => ({
          ...(prev ?? {}),
          [field]: 'Please enter description',
        }));
      }
    }
  };

  const checkErrors = () => {
    const keys = Object.keys(errors);
    if (keys?.length > 0) return true;
    else return false;
  };

  const checkValues = () => (project?.project_name && project?.project_type ? false : true);

  // hideList

  // display functions
  const displayProjectOptions = () => {
    const keys = Object.keys(ProjectTypeEnum1);
    return keys?.map((each) => {
      const value = (ProjectTypeEnum1 as any)?.[each];
      return (
        <option value={value} key={each}>
          {text_convert_lower(value)}
        </option>
      );
    });
  };


  const engines = Object.values(engineTypes)
  const displayEngines = () => {
    return engines?.map((each: any) => {
      return (
        <option value={each} key={each}>
          {text_convert_lower(each)}
        </option>
      );
    });
  }

  // Dunamic OPEN_AI models
  const [dynamicModels, setDynamicModels] = useState<any>();
  // Dynamic Engine models
  const engineModels =
    [
      { engine: engineTypes.OPEN_AI, models: dynamicModels || docAiEngineTypes},
      { engine: engineTypes.OPEN_SOURCE, models: Object.values(openSourceTypes) }
    ]
  const [models, setModels] = useState<any>(engineModels[0]?.models)
  const displayModels = () => {
    return models?.map((each: any) => {
      return (
        <option value={each} key={each}>
          {text_convert_lower(each)}
        </option>
      );
    });
  }

  const embeddedModels = embeddedModelTypesUpdated;
  // Object.values(embeddedModelTypes)
  const displayEmbeddedModels = () => {
    return embeddedModels?.map((each: any) => {
      return (
        <option value={each?.value} key={each?.label}>
          {text_convert_lower(each?.label)}
        </option>
      );
    });
  }

  useEffect(() => {
    const initialProjectValues = {
      open_ai_key: openAikeyTypes.openAiKey,
      llamaparse_api_key: openAikeyTypes.llamaparseApiKey,
      engine: engineTypes.OPEN_AI,
      model:  engineModels[0]?.models[0],
      // openAITypes.GPT35TURBO16K0613,
      embeddedModal: embeddedModelTypes.ADAV2,
      temperature: 0 ,
      project_description:'',
      chunk_overlap: 250 ,
      chunk_size: 2040,
    }
    setProject({ ...selectedProject, ...initialProjectValues}
    )
  }, [])

  return (
    <div className="project-form">
      <Form>
        <div className="input-row">
          <FormGroup className={`project-input name ${errors?.project_name ? 'error-input' : ''}`}>
            <Label for="project-name">Name<span className='required'>*</span></Label>
            <Input
              id="project-name"
              name="project-name"
              placeholder="Enter the solution name"
              type="text"
              value={project?.project_name}
              onChange={(e) => {
                handleChange(e?.target?.value, "project_name");
                validateFields(e?.target?.value, "project_name");
              }}
              onBlur={(e) => {
                validateFields(e?.target?.value, "project_name");
              }}
              disabled={!!selectedProject}
            />
            {errors?.project_name ? (
              <div className="error-field" color="danger">
                {errors?.project_name}
              </div>
            ) : (
              <></>
            )}
          </FormGroup>
        </div>
        <div className="input-row">
          <FormGroup className={`project-input type ${errors?.project_type ? 'error-input' : ''}`}>
            <Label for="eproject-type">Solution Type<span className='required'>*</span></Label>
            <Input
              id="project-type"
              name="project-type"
              type="select"
              value={project?.project_type}
              onChange={(e) => handleChange(e?.target?.value, "project_type")}
              disabled={!!selectedProject}
            >
              <option value={""}>Select Solution type</option>
              {displayProjectOptions()}
            </Input>
          </FormGroup>
          <FormGroup className={`project-input version ${errors?.version ? 'error-input' : ''}`}>
            <Label for="project-name">Version<span className='required'>*</span></Label>
            <Input
              id="project-version"
              name="project-version"
              type="text"
              value={selectedProject ? project?.version : "0.1"}
              onChange={(e) => {
                handleChange(e?.target?.value, "version");
                validateFields(e?.target?.value, "version");
              }}
              onBlur={(e) => {
                validateFields(e?.target?.value, "version");
              }}
              disabled={!selectedProject}
            />
            {errors?.version ? (
              <div className="error-field" color="danger">
                {errors?.version}
              </div>
            ) : (
              <></>
            )}
          </FormGroup>
        </div>
        <div className="input-row">
          <FormGroup className={`project-input name ${errors?.project_name ? 'error-input' : ''}`}>
            <Label for="project-name">Solution Description <span className='required'>*</span></Label>
            <Input
              id="project-description"
              name="project-description"
              placeholder="Enter the project description"
              type="textarea"
              value={project?.project_description}
              onChange={(e) => {
                handleChange(e?.target?.value, "project_description");
                // validateFields(e?.target?.value, "project_name");
              }}
              onBlur={(e) => {
                validateFields(e?.target?.value, "project_description");
              }}
              // onBlur={(e) => {
              //   validateFields(e?.target?.value, "project_name");
              // }}
              disabled={!!selectedProject}
            />
             {errors?.project_description ? (
              <div className="error-field" color="danger">
                {errors?.project_description}
              </div>
            ) : (
              <></>
            )}
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="open_ai_key">Api Key</Label>
            <Input
              id="open_ai_key"
              name="open_ai_key"
              placeholder="Enter Api Key"
              // type='password'
              value={project?.open_ai_key}
              autoComplete='off'
              onChange={(e) => handleChange(e?.target?.value, "open_ai_key")}
            >
            </Input>
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="llamaparse_api_key">Llamaparse Api Key</Label>
            <Input
              id="llamaparse_api_key"
              name="llamaparse_api_key"
              placeholder="Enter Llamaparse Api Key"
              // type='password'
              value={project?.llamaparse_api_key}
              autoComplete='off'
              onChange={(e) => handleChange(e?.target?.value, "llamaparse_api_key")}
            >
            </Input>
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="engine">Engine</Label>
            <Input
              id="engine"
              name="engine"
              placeholder="Choose LLMs"
              type="select"
              value={project?.engine}
              onChange={(e) => handleChange(e?.target?.value, "engine")}
            >
              <option value={""}>Select engine</option>
              {displayEngines()}
            </Input>
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="model">Model</Label>
            <Input
              id="model"
              name="model"
              type="select"
              placeholder="Please enter the name"
              value={project?.model}
              onChange={(e) => handleChange(e?.target?.value, "model")}
            >
              <option value={""}>Select model</option>
              {displayModels()}
            </Input>
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="embeddedModal">Embedded Modal</Label>
            <Input
              id="embeddedModal"
              name="embeddedModal"
              placeholder="Please enter the name"
              type='select'
              value={project?.embeddedModal}
              onChange={(e) => handleChange(e?.target?.value, "embeddedModal")}
            >
              {displayEmbeddedModels()}
            </Input>
          </FormGroup>
        </div>
        <div className="name">
          <FormGroup>
            <Label for="temperature">Tempareture {(project?.temperature / 10) ? project?.temperature / 10 : 0}</Label>
            <Input
              id="temperature"
              name="temperature"
              type='range'
              placeholder="Please enter the name"
              min={1}
              max={10}
              value={project?.temperature}
              onChange={(e) => handleChange(e?.target?.value, "temperature")}
            />
          </FormGroup>
        </div>
        <div className="name">
            <FormGroup>
              <Label for="chunk_overlap">chunk Overlap {project?.chunk_overlap}</Label>
              <Input
                id="chunk_overlap"
                name="chunk_overlap"
                type='range'
                placeholder="Please enter the name"
                min={250}
                max={5000}
                value={project?.chunk_overlap}
                onChange={(e) => handleChange(e?.target?.value, "chunk_overlap")}
              />
            </FormGroup>
          </div>
          <div className="name">
            <FormGroup>
              <Label for="chunk_size">chunk Size {project?.chunk_size}</Label>
              <Input
                id="chunk_size"
                name="chunk_size"
                type='range'
                placeholder="Please enter the name"
                min={250}
                max={5000}
                value={project?.chunk_size}
                onChange={(e) => handleChange(e?.target?.value, "chunk_size")}
              />
            </FormGroup>
          </div>
        <div className="btns">
          <Button
            className="cancel"
            onClick={() => cancelProject(project)}
          >
            Cancel
          </Button>
          <Button
            className="submit"
            disabled={checkErrors() || checkValues()}
            onClick={() => submitProject(project)}
          >
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ProjectForm;
